import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import {BsModalRef, BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  public api = api;
  public env = environment;
  modalRef!: BsModalRef;
  public menu: any[] = [];
  public isLoading = false;
  private subs: Subscription[] = [];
  @ViewChild('rule', { static: true }) public ruleModal!: ModalDirective;
  @ViewChild('privacyPolicy', { static: true }) public privacyPolicyModal!: ModalDirective;
  // public data: any;
  // public isLogin : boolean = false;
  constructor(private modalService: BsModalService,
    private router: Router,
    public _common: CommonService,
    public _shared: SharedService,
    public service: WebserviceService,
    private _message: MessageService) { }
  // constructor(private router: Router) { }

  ngOnInit(): void {
    // if (localStorage.getItem(`${this.env.panel}id_token`)) {
    //   this.router.navigate(["/dashboard"]);
    //   // this.isLogin = true;
    // }

    this.menu = (localStorage.getItem(`${this.env.panel}menu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}menu`) as any) : [];
    if (this.menu.length == 0) { this.getMenu(); }
    this.getListData();
    this.getRaceListData(7);
    this.getRaceListData(4339);
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getListData() {
    this.isLoading = true;
    let url = this._common.getToken() ? this.api.eventList : this.api.eventListG
    this.getServices().Get(`${this.env.baseUrl + url}`).subscribe(
      (res) => {
        if (res.status == true) {
          // this.baseUrl = (res.data.connect_odds_hub == true) ? `https://${res.data.odds_hub}` : this.env.baseUrl;
          res.data.events = this._common.UTC_to_Local_timeZone(res.data.events);

          // sidemenu content
          localStorage.removeItem(`${this.env.panel}sideMenu`);
          localStorage.setItem(`${this.env.panel}sideMenu`, JSON.stringify(res.data.events));
          this._shared.emitSideMenu(res.data.events);

          this.menu.forEach(element => {
            element["data"] = [];
            res.data.events.forEach((event: any) => {
              if (element.id == event.event_type_id && event?.in_play == 1) {
                element.data.push(event);
              }
            });
          });
          // console.log(this.menu);
          this.isLoading = false;

        }
      },
      (err) => {
        console.log(err);
        this.isLoading = false;
      });
  }
  getRaceListData(id: any) {
    let url = this._common.getToken() ? this.api.raceList : this.api.raceListG
    this.getServices().Get(`${this.env.baseUrl + url}/${id}`).subscribe(
      (res) => {
        if (res.status == true) {
          res.data.race = this._common.UTC_to_Local_timeZone(res.data.race);

          localStorage.removeItem(`${this.env.panel}sideRaceMenu${id}`);
          localStorage.setItem(`${this.env.panel}sideRaceMenu${id}`, JSON.stringify(res.data.race));
          this._shared.emitSideMenu(res.data.race);

          this.menu.forEach(element => {
            if (element.id == id) {
              res.data.race.forEach((ele: any) => {
                if (ele?.in_play == 1) {
                  element.data.push(ele);
                }
              });
            }
          });


          // remove raceData from this.data
          // this.data = this.data.filter((item: any) => {
          //   return item.event_type_id != id
          // });

          // this.data = [...this.data, ...res.data.race]
          // this.marketsReq = market.join('&') as any;




          // this.getOdds(this.marketsReq, this.data);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  getMenu() {
    this.getServices().Get(`${this.env.baseUrl + this.api.menu}`).subscribe(
      (res) => {
        if (res.status == true) {
          if (!localStorage.getItem(`${this.env.panel}stakes`)) {
            localStorage.removeItem(`${this.env.panel}stakes`);
            localStorage.setItem(`${this.env.panel}stakes`, JSON.stringify(this.env.stakes));
          }
          localStorage.removeItem(`${this.env.panel}menu`);
          localStorage.setItem(`${this.env.panel}menu`, JSON.stringify(res?.data?.menu));
          this.menu = res?.data?.menu;
          this._shared.emitSideMenu('');
        }
      },
      (err) => {
        console.log(err);
      });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-ui' });
  }

  closeModel() {
    this.modalRef!.hide();
  }

  openAppMoadal(template: TemplateRef<any>) {
    this.modalRef!.hide();
    this.openModal(template);
  }

  redirectList(id: any) {
    if (localStorage.getItem(`${this.env.panel}id_token`)) {
      this.router.navigate(['/sports', id]);
    } else {
      this.router.navigate(['guest/sports', id]);
    }
  }

  redirectCasino() {
    // if (localStorage.getItem(`${this.env.panel}id_token`)) {
    //   this.router.navigate(['/casino']);
    // } else {
    //   this.router.navigate(['casino']);
    // }
  }
  redirectCasinoI() {
    if (localStorage.getItem(`${this.env.panel}id_token`)) {
      this.router.navigate(['/sports/99995']);
    } else {
      this.router.navigate(['/guest/sports/99995']);
    }
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  openRuleModal() {
    this.ruleModal!.show();
  }

  openPrivacyPolicyModal() {
    this.privacyPolicyModal!.show();
  }

}
